<template>
    <v-container fluid>
        <v-col class="ma-0 pa-0">
            <v-row class="ma-1" align="center" justify="center">
                <v-btn large color="primary" class="textButton" width="50%" @click="redirecionaSite('conectividade')">CONECTIVIDADE</v-btn>
            </v-row>
            <v-row class="ma-1" align="center" justify="center">
                <v-btn large color="primary" class="textButton" width="50%" @click="redirecionaSite('pizzaline')">PIZZA</v-btn>
            </v-row>
        </v-col>
    </v-container>
</template>

<script>

export default {
    name: 'Exemplos',
	data: function () {
		return { }
	},
	methods: {
        redirecionaSite(identificador){
            window.location.href = `https://sicecommerce.com.br/${identificador}`
        }
    },
}

</script>
<style scoped>
    .textButton{
        font-size: 18px;
        font-weight: bold;
        color: white;
    }
</style>